// Renders a leaderboard list (rank · flag · name · score). Shared by the game-over
// screen and the pause menu.

import { flagEmoji } from '../net/leaderboardClient';
import type { LeaderEntry } from '../net/leaderboardClient';
import { avatarCanvas } from '../render/pixelArt';

const RANK_COLOR = ['#ffd34d', '#cfd2dd', '#e0915a']; // gold / silver / bronze

export function renderLeaderboard(entries: LeaderEntry[], highlight?: { name: string; score: number }): HTMLElement {
  const wrap = document.createElement('div');
  Object.assign(wrap.style, { display: 'flex', flexDirection: 'column', gap: '3px', width: '100%' });

  if (entries.length === 0) {
    wrap.textContent = 'No scores yet - be the first!';
    Object.assign(wrap.style, { textAlign: 'center', color: '#9a93b0', padding: '20px 0' });
    return wrap;
  }

  entries.forEach((e, i) => {
    const me = highlight !== undefined && e.name === highlight.name && e.score === highlight.score;
    const row = document.createElement('div');
    Object.assign(row.style, {
      display: 'grid',
      gridTemplateColumns: '28px 24px 1fr auto',
      alignItems: 'center',
      gap: '8px',
      padding: '4px 8px',
      borderRadius: '4px',
      background: me ? 'rgba(95,200,255,0.16)' : i % 2 === 0 ? 'rgba(255,255,255,0.03)' : 'transparent',
      border: me ? '1px solid #5cc8ff' : '1px solid transparent',
      fontSize: '13px',
    });

    const rank = document.createElement('div');
    rank.textContent = `${i + 1}`;
    Object.assign(rank.style, { color: RANK_COLOR[i] ?? '#9a93b0', fontWeight: '700', textAlign: 'right' });

    const av = avatarCanvas(e.avatar ?? 0, 2);
    av.style.justifySelf = 'center';

    const who = document.createElement('div');
    who.textContent = `${flagEmoji(e.country)}  ${e.name}`;
    Object.assign(who.style, { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: me ? '#fff' : '#e8e4f0' });

    const score = document.createElement('div');
    score.textContent = e.score.toLocaleString();
    Object.assign(score.style, { color: '#9fd4ff', fontWeight: '700' });

    row.append(rank, av, who, score);
    wrap.appendChild(row);
  });
  return wrap;
}
